module.exports = __webpack_public_path__ + "static/media/color-check.ac95a687.svg";